<template>
  <v-container>
    <app-modal v-model="showModal" max-width="1200" persistent>
      <template v-slot:title>{{ title }}</template>
      <template v-slot:text>
        <div class="text-xs-center" v-show="showLoading">
          <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
          <h2>Loading...</h2>
        </div>
        <v-form v-model="valid" ref="form" lazy-validation v-show="!showLoading">
          <v-subheader class="headline">General</v-subheader>
          <ImporterGeneral :Title="title" :data="generalData" :ImporterType="ImporterType" @setGeneralData="setGeneralData" />
          <br>
          <v-divider></v-divider>
          <v-subheader class="headline">Shared</v-subheader>
          <v-layout>
            <v-flex xs6 pr-3>
              <v-text-field label="OptimumStationId" :rules="numRuleNoZero" v-model="OptimumStationId">
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">info_outline</v-icon>
                    </template>
                    System uses the optimum station Id to download the logger information.
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs6 pl-3>
              <v-text-field label="Data Logger Name" :rules="nullRule" v-model="DataLoggerName">
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">info_outline</v-icon>
                    </template>
                    System uses the data logger name to filter the inputs for the stations.
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <v-text-field label="AccessToken" v-model="AccessToken" :rules="nullRule">
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">info_outline</v-icon>
                  </template>
                  Authentication access token for optimum API calls.
                </v-tooltip>
              </template>
            </v-text-field>
          </v-flex>
          <br>
          <v-divider></v-divider>
          <v-subheader class="headline">Mappings</v-subheader>
          <v-text-field label="HotFolderName" v-model="NGConfig.HotFolderName" :rules="nullRule"></v-text-field>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="save()" :disabled="!canSave" :loading="btnLoading">
          <v-icon>done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn color="secondary" @click="close()" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <app-confirmation-modal v-model="saveFailed" max-width="500">
      <template slot="title">
        Failed
      </template>
      <template slot="text">
        {{ errorMessage }}
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="saveFailed = false" outline>Cancel</v-btn>
      </template>
    </app-confirmation-modal>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  import AppModal from '@/components/generic/AppModal'
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import ImporterGeneral from '@/components/Administration/ContinuousDataImportModal/ImporterGeneral'
  import ImporterAlert from '@/components/Administration/ContinuousDataImportModal/ImporterAlert'
  import ImporterConfigUtil from '@/components/mixins/ImporterConfigUtil'
  import ImporterStationSelector from '@/components/Administration/ContinuousDataImportModal/ImporterStationSelector'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import { createNamespacedHelpers } from 'vuex'
  const continuousimporterconfig = createNamespacedHelpers('continuousimporterconfig')

  export default {
    components: {
      ImporterStationSelector,
      ImporterGeneral,
      ImporterAlert,
      'app-modal': AppModal,
      'app-confirmation-modal': AppConfirmationModal,
    },
    mixins: [SnackBarUtil, ImporterConfigUtil],
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      importerId: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        valid: true,
        showLoading: false,
        btnLoading: false,
        saveFailed: false,
        errorMessage: '',
        model: 'tab-1',
        showModal: false,
        Name: '',
        Description: '',
        ExecuteInterval: '',
        DataLoggerName: '',
        OptimumStationId: '',
        AccessToken: '',
        NGConfig: {
          Station: {},
          HotFolderName: '',
        },
      }
    },
    computed: {
      ...continuousimporterconfig.mapGetters(['ImporterConfigs', 'AQUARIUS_SERVER_NG', 'IMPORTER_TYPE_Optimum']),
      ImporterType() {
        return this.IMPORTER_TYPE_Optimum
      },
      sharedCheck() {
        return this.DataLoggerName && this.OptimumStationId && this.AccessToken
      },
      mappingCheck() {
        return this.NGConfig.HotFolderName
      },
    },
    watch: {
      value(v) {
        this.updateFormValue(v)
      },
      showModal(v) {
        if (!v) {
          this.close()
        }
      },
    },
    methods: {
      ...continuousimporterconfig.mapActions(['addImporterConfig', 'updateImporterConfig', 'getImporterDetail']),
      async updateFormValue(v) {
        this.showModal = v
        if (this.showModal && this.importerId != 0) {
          this.showLoading = true
          let options = {
            data: this.importerId,
          }
          let result = await this.getImporterDetail(options)
          this.Name = result.Name
          this.Description = result.Description
          this.ExecuteInterval = result.ExecuteInterval
          this.DataLoggerName = result.DataLoggerName
          this.OptimumStationId = result.OptimumStationId
          this.AccessToken = result.AccessToken
          this.NGConfig = {
            HotFolderName: result.NG_DataFolder.HotFolderName,
          }
          this.showLoading = false
        }
      },
      clearAll() {
        this.$refs.form.resetValidation()
        this.model = 'tab-1'
        this.Name = ''
        this.Description = ''
        this.ExecuteInterval = ''
        this.DataLoggerName = ''
        this.OptimumStationId = ''
        this.AccessToken = ''
        this.NGConfig = {
          Station: {},
          HotFolderName: '',
        }
      },
      save() {
        this.btnLoading = true
        let options = {
          data: {
            Id: this.importerId,
            Name: this.Name,
            ImporterType: this.ImporterType,
            ExecuteInterval: this.ExecuteInterval,
            DataLoggerName: this.DataLoggerName,
            Description: this.Description,
            OptimumStationId: this.OptimumStationId,
            AccessToken: this.AccessToken,
            NG_DataFolder: {
              HotFolderName: this.NGConfig.HotFolderName,
            },
          },
          successCb: () => {
            this.saveSuccess()
            this.btnLoading = false
            this.close()
          },
          failedCb: (err) => {
            this.btnLoading = false
            this.saveFailed = true
            this.errorMessage = err
          },
        }
        if (this.importerId) {
          this.updateImporterConfig(options)
        } else {
          this.addImporterConfig(options)
        }
      },
      setGeneralData(data) {
        this.Name = data.Name
        this.Description = data.Description
        this.ExecuteInterval = data.ExecuteInterval
      },
    },
    mounted() {
      this.$refs.form.resetValidation()
      this.updateFormValue(this.value)
    },
  }
</script>